import { Box, styled } from "@mui/material";

const StyledClientCard = styled(Box)(({ theme }) => ({
    padding: theme.spacing(2),
    boxSizing: "border-box",
    borderRadius: (theme as any).shape.border.general.radius[9],
    backgroundColor: (theme as any).palette.neutral.darkest,
    width: '100%',
}))

export { StyledClientCard }

